import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-78a78efe")

_pushScopeId("data-v-78a78efe")
const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "el-icon-document" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("套卡列表")
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "el-icon-crop" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("项目列表")
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "el-icon-files" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("卡牌总览")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_menu = _resolveComponent("el-menu")
  const _component_el_aside = _resolveComponent("el-aside")
  const _component_router_view = _resolveComponent("router-view")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock(_component_el_container, { class: "padding-20" }, {
    default: _withId(() => [
      _createVNode(_component_el_aside, { width: "240px" }, {
        default: _withId(() => [
          _createVNode(_component_el_menu, {
            "default-active": _ctx.$route.name,
            class: "el-menu-vertical-demo",
            router: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_menu_item, {
                index: "CardSetList",
                route: {name: 'CardSetList'}
              }, {
                title: _withId(() => [
                  _hoisted_2
                ]),
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                index: "CardKeywordList",
                route: {name: 'CardKeywordList'}
              }, {
                title: _withId(() => [
                  _hoisted_4
                ]),
                default: _withId(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                index: "AllCardList",
                route: {name: 'AllCardList'}
              }, {
                title: _withId(() => [
                  _hoisted_6
                ]),
                default: _withId(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["default-active"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_main, null, {
        default: _withId(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})